"use strict";

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Select from 'react-select';
const {
  app
} = window;
export default class SelectV2 extends Component {
  getDefaultValue = () => {
    const component = this,
      props = this.props;
    const update = {
      no_matched_option: false
    };
    if (props.options?.length > 0 && props.value) {
      const opt = this.props.options.find(opt => opt.value === props.value);
      update.selected_option = opt;
    }
    if (!update.selected_option) {
      update.no_matched_option = true;
      update.selected_option = {
        label: '',
        value: ''
      };
    }
    return update;
  };
  state = {
    ...this.getDefaultValue()
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props['default-value']) {
      const opt = props.options.find(opt => opt.value === props['default-value']);
      if (opt) component.setState({
        selected_option: opt
      });
    } else {
      props.onChange({
        e: null,
        value: '',
        name: props.name,
        source: 'DidMount'
      });
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.value !== props.value) {
      component.setSelectedOption();
    }
  }
  setSelectedOption = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const opt = props.options.find(opt => opt.value === props.value);
    if (opt) {
      component.setState({
        selected_option: opt,
        no_matched_option: false
      });
    } else {
      component.setState({
        no_matched_option: true,
        selected_option: {
          label: '',
          value: ''
        }
      });
    }
  };
  handleChange = ({
    label,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    props.onChange({
      e: undefined,
      value: value,
      name: props.name,
      source: 'Native'
    });
  };
  setRef = ref => {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.onRef) {
      component.ref = ref;
      props.onRef(ref);
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const options = props.options.slice(0);
    let effective_value = state.selected_option;
    if (state.no_matched_option === true) {
      const empty_option = {
        label: props.placeholder || '',
        value: ''
      };
      options.unshift(empty_option);
      effective_value = empty_option;
    }
    const output = /*#__PURE__*/React.createElement(Select, {
      options: props.options,
      className: props.className,
      onChange: component.handleChange,
      onKeyDown: props.onKeyDown,
      value: effective_value,
      autoFocus: props.autoFocus,
      isDisabled: props.disabled === true,
      innerRef: props.innerRef,
      ref: component.setRef
    });
    return output;
  }
}
Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  status: PropTypes.object,
  options: PropTypes.array,
  style: PropTypes.object,
  disabled: PropTypes.bool
};
Select.defaultProps = {
  placeholder: '',
  value: '',
  options: [],
  status: {},
  style: undefined,
  disabled: false
};
